/**
 * WorkDocStatusBar — Bottom status bar with word/character count and page info.
 */
export default function WorkDocStatusBar({ wordCount = 0, charCount = 0, editor }) {
  return (
    <div className="flex items-center justify-between px-4 py-1.5 bg-gray-900 border-t border-gray-700 text-[10px] text-gray-500">
      <div className="flex items-center gap-4">
        <span>Words: <strong className="text-gray-400">{wordCount}</strong></span>
        <span>Characters: <strong className="text-gray-400">{charCount}</strong></span>
      </div>
      <div className="flex items-center gap-2">
        {editor && (
          <>
            <span>
              Line: <strong className="text-gray-400">
                {editor.state.selection.$anchor?.pos !== undefined
                  ? (editor.state.doc.textBetween(0, editor.state.selection.$anchor.pos).match(/\n/g)?.length || 0) + 1
                  : 1}
              </strong>
            </span>
            <span>|</span>
          </>
        )}
        <span>AllBaise WorkDocs</span>
      </div>
    </div>
  );
}
